import React from 'react';

// Les noms des champs requis encore vides, une fois qu'un envoi a été refusé (vide tant que la personne n'a pas tenté d'envoyer)
export const MissingFieldsContext = React.createContext(new Set());
